import React from 'react';
import {
  AtRiskTringleIcon,
  CriticalCircleIcon,
  GreenTickIcon,
} from '@/assets/icons/icons';
import { GxpBanner } from './types';

const ICONS_BY_STATUS: Record<string, React.ReactNode> = {
  pass: <GreenTickIcon color='#fff' />,
  warning: <AtRiskTringleIcon color='#fff' width={16} height={16} />,
  critical: <CriticalCircleIcon color='#fff' width={16} height={16} />,
  fail: <CriticalCircleIcon color='#fff' width={16} height={16} />,
  danger: <CriticalCircleIcon color='#fff' width={16} height={16} />,
  other: <AtRiskTringleIcon color='#fff' width={16} height={16} />,
};

interface StatusBannerProps {
  banner: GxpBanner;
}

const StatusBanner: React.FC<StatusBannerProps> = ({ banner }) => {
  return (
    <div className={`gxp-banner gxp-banner--${banner.status}`}>
      <span className='gxp-banner-icon'>
        {ICONS_BY_STATUS[banner?.status ?? 'other']}
      </span>
      <div className='gxp-banner-copy'>
        <div className='gxp-banner-title'>{banner?.title}</div>
        <div className='gxp-banner-description'>{banner?.message}</div>
      </div>
    </div>
  );
};

export default StatusBanner;
